import mandatoryLoginProductItem from "./mandatoryLoginProductItem"
export default mandatoryLoginProductItem;
